import React, { useState, useRef } from "react";
import { Box, Typography, Button } from "@mui/material";
import { Wheel } from "react-custom-roulette";
import Confetti from "react-confetti";

const prizes = [
  {
    option: "Free Fries",
    style: { backgroundColor: "#FF6B6B", textColor: "white" },
  },
  {
    option: "10% Off",
    style: { backgroundColor: "#FF8C00", textColor: "white" },
  },
  {
    option: "Free Drink",
    style: { backgroundColor: "#FFD700", textColor: "#FF6B6B" },
  },
  {
    option: "20% Off",
    style: { backgroundColor: "#FF69B4", textColor: "white" },
  },
  {
    option: "Free Burger",
    style: { backgroundColor: "#9370DB", textColor: "white" },
  },
  {
    option: "15% Off",
    style: { backgroundColor: "#FF6B6B", textColor: "white" },
  },
  {
    option: "Free Dessert",
    style: { backgroundColor: "#FF8C00", textColor: "white" },
  },
  {
    option: "25% Off",
    style: { backgroundColor: "#FFD700", textColor: "#FF6B6B" },
  },
];

const SpinGame = ({ size = 275 }) => {
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [isSpinning, setIsSpinning] = useState(false);
  const [result, setResult] = useState(null);
  const [showConfetti, setShowConfetti] = useState(false);
  const [confettiVisible, setConfettiVisible] = useState(false);
  const cardRef = useRef(null);
  const [confettiDims, setConfettiDims] = useState({ width: 0, height: 0 });

  const handleSpinClick = () => {
    if (isSpinning) return;
    const newPrizeNumber = Math.floor(Math.random() * prizes.length);
    setPrizeNumber(newPrizeNumber);
    setMustSpin(true);
    setIsSpinning(true);
    setResult(null);
    setShowConfetti(false);
    setConfettiVisible(false);
  };

  const handleStopSpinning = () => {
    setMustSpin(false);
    setIsSpinning(false);
    setResult(prizes[prizeNumber].option);
    if (cardRef.current) {
      const rect = cardRef.current.getBoundingClientRect();
      setConfettiDims({ width: rect.width, height: rect.height });
    }
    setShowConfetti(true);
    setTimeout(() => setConfettiVisible(true), 10); // trigger fade-in immediately
    setTimeout(() => setConfettiVisible(false), 3200); // start fade-out
    setTimeout(() => setShowConfetti(false), 4000); // remove from DOM
  };

  return (
    <Box
      ref={cardRef}
      sx={{
        background: "#FFF5F5",
        borderRadius: "16px",
        p: 3,
        textAlign: "center",
        color: "black",
        position: "relative",
        overflow: "hidden",
        border: "4px solid #FF6B6B",
        width: "100%",
      }}
    >
      {showConfetti && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: confettiDims.width,
            height: confettiDims.height,
            pointerEvents: "none",
            opacity: confettiVisible ? 1 : 0,
            transition: "opacity 0.7s cubic-bezier(.4,0,.2,1)",
            zIndex: 2,
          }}
        >
          <Confetti
            numberOfPieces={180}
            recycle={false}
            width={confettiDims.width}
            height={confettiDims.height}
          />
        </div>
      )}
      <Typography variant="h5" sx={{ mb: 2 }}>
        🎡 Spin to Win!
      </Typography>
      <Typography sx={{ mb: 3 }}>
        Spin the wheel for a chance to win free food or discounts!
      </Typography>
      <Box
        sx={{
          width: size,
          height: size,
          mx: "auto",
          mb: 3,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "& > *": {
            width: "100% !important",
            height: "100% !important",
            maxWidth: "100% !important",
            maxHeight: "100% !important",
          },
        }}
      >
        <Wheel
          mustStartSpinning={mustSpin}
          prizeNumber={prizeNumber}
          data={prizes}
          backgroundColors={[
            "#FF6B6B",
            "#FF8C00",
            "#FFD700",
            "#FF69B4",
            "#9370DB",
          ]}
          textColors={["white"]}
          outerBorderColor={"#FF6B6B"}
          outerBorderWidth={8}
          innerBorderColor={"#FF6B6B"}
          innerBorderWidth={4}
          radiusLineColor={"#fff"}
          radiusLineWidth={2}
          fontSize={24}
          spinDuration={0.7}
          pointerProps={{ style: { fill: "#FF6B6B" } }}
          onStopSpinning={handleStopSpinning}
        />
      </Box>
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <Button
          variant="contained"
          onClick={handleSpinClick}
          disabled={isSpinning}
          sx={{
            backgroundColor: "white",
            color: "#FF6B6B",
            px: 4,
            py: 2,
            borderRadius: "100px",
            fontSize: "1.2rem",
            fontWeight: 700,
            textTransform: "none",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.95)",
              color: "#FF6B6B",
              transform: "translateY(-2px)",
              boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
            },
            "&:disabled": {
              backgroundColor: "rgba(255,255,255,0.5)",
              color: "rgba(255,107,107,0.5)",
            },
          }}
        >
          {isSpinning ? "Spinning..." : "SPIN"}
        </Button>
        {result && (
          <Typography
            sx={{
              mt: 3,
              fontWeight: 700,
              fontSize: "1.1rem",
              color: "black",
              display: "block",
              animation: "pop-in 0.5s cubic-bezier(.68,-0.55,.27,1.55)",
            }}
          >
            🎉 Congratulations! <br />
            You won: {result}
          </Typography>
        )}
      </Box>
      <style>{`
        @keyframes pop-in {
          0% { transform: scale(0.7); opacity: 0; }
          60% { transform: scale(1.15); opacity: 1; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </Box>
  );
};

export default SpinGame;
